import ApiService from './ApiService'

const ROOT_URL = '/services/onboarding/api/facerecognition/private';

const FaceRecognitionApi = new ApiService(ROOT_URL, '', {
  calculate: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, '/check', data, onSuccess, onError, true);
  }
});

export default FaceRecognitionApi;



// WEBPACK FOOTER //
// ./src/service/FaceRecognitionService.js